import React from "react";
import DashboardLayout from "@/components/DashboardLayout";
import { LayoutDashboard, BookOpen, Award, CalendarClock, Bell, User, Receipt, ClipboardCheck, FolderOpen, MessageSquare, LifeBuoy, Sparkles, Search } from "lucide-react";

const NAV = [
  { to: "/app/alumno", label: "Panel", icon: LayoutDashboard, end: true },
  { to: "/app/alumno/programas", label: "Mis Programas", icon: BookOpen },
  { to: "/app/alumno/tareas", label: "Tareas", icon: ClipboardCheck },
  { to: "/app/alumno/biblioteca", label: "Biblioteca", icon: FolderOpen },
  { to: "/app/foros/buscar", label: "Buscar en foros", icon: Search },
  { to: "/app/alumno/mensajes", label: "Mensajes", icon: MessageSquare },
  { to: "/app/alumno/calendario", label: "Calendario", icon: CalendarClock },
  { to: "/app/alumno/suscripcion", label: "Suscripción", icon: Sparkles },
  { to: "/app/alumno/ordenes", label: "Mis Órdenes", icon: Receipt },
  { to: "/app/alumno/certificados", label: "Certificados", icon: Award },
  { to: "/app/alumno/sesiones", label: "Sesiones vivo", icon: CalendarClock },
  { to: "/app/alumno/soporte", label: "Soporte", icon: LifeBuoy },
  { to: "/app/alumno/notificaciones", label: "Notificaciones", icon: Bell },
  { to: "/app/alumno/perfil", label: "Perfil", icon: User },
];

function tenantSlugFor(user) {
  if (!user?.email) return "dcc";
  if (user.email.includes("banco-alfa")) return "banco-alfa";
  if (user.email.includes("demo-bank")) return "demo-bank";
  return "dcc";
}

export default function AlumnoLayout({ user, children }) {
  return (
    <DashboardLayout title="Campus del Alumno" navItems={NAV} tenantSlug={tenantSlugFor(user)}>
      {children}
    </DashboardLayout>
  );
}
